export const REMEMBER_USER_INFO = {
  SELLER_NUMBER: 'rememberSellerNumber',
  ACCOUNT: 'rememberAccount',
};

export const AUTO_UPDATE_INTERVAL = 5000;
